/*
 * Keeps each hidden "Monogram Embroidery" fee line in sync with its garment line.
 * Garment and fee lines are linked by a shared `_monogram_ref` line item property.
 * On every cart update it sets the fee quantity to match the garment quantity
 * (0 = garment removed = fee removed). Covers the theme cart + drawer; Shopify's
 * hosted checkout cannot run this (Basic plan = no Scripts/Functions).
 */
(function () {
  if (window.__monogramCartSync) return;
  window.__monogramCartSync = true;

  let syncing = false;

  function getCart() {
    return fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }

  function reconcile() {
    if (syncing) return Promise.resolve();

    return getCart()
      .then((cart) => {
        const items = (cart && cart.items) || [];
        const groups = {};

        items.forEach((item) => {
          const props = item.properties || {};
          const ref = props._monogram_ref;
          if (!ref) return;
          if (!groups[ref]) groups[ref] = { garmentQty: 0, fees: [] };
          if (props._monogram_fee) groups[ref].fees.push(item);
          else groups[ref].garmentQty += item.quantity;
        });

        const updates = {};
        Object.keys(groups).forEach((ref) => {
          const group = groups[ref];
          group.fees.forEach((fee) => {
            if (fee.quantity !== group.garmentQty) updates[fee.key] = group.garmentQty;
          });
        });

        if (Object.keys(updates).length === 0) return;

        syncing = true;
        return fetch(`${routes.cart_update_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        })
          .then((r) => r.json())
          .then((newCart) => {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'monogram-sync', cartData: newCart });
            }
          })
          .catch((error) => console.error('[monogram] cart sync failed', error))
          .finally(() => {
            syncing = false;
          });
      })
      .catch((error) => console.error('[monogram] cart read failed', error));
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'monogram-sync') return;
      reconcile();
    });
  }

  document.addEventListener('DOMContentLoaded', reconcile);
})();
